import React from "react";
import { FormData } from "types/gql-types";

export default React.createContext<null | FormData>(null);
